import React, { useState } from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Collapse, Box, Stack, Typography } from "@mui/material";
import AccountCircleOutlined from "@mui/icons-material/AccountCircleOutlined";

const CustomSimpleAccordion = ({ title, content, defaultOpen = false }) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  const handleToggle = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div
      className="qub-simple-accordion"
      style={{
        border: "1px solid #ccc",
        overflow: "hidden",
      }}
    >
      <button
        onClick={handleToggle}
        style={{
          cursor: "pointer",
          padding: "10px 15px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          width: "100%",
        }}
      >
        <div>{title}</div>
        <ExpandMoreIcon
          style={{
            transition: "transform 0.3s ease",
            transform: isOpen ? "rotate(180deg)" : "rotate(0deg)",
          }}
        />
      </button>
      <Collapse in={isOpen} timeout="auto">
        <Box
          sx={{
            padding: "10px 15px",
            backgroundColor: "#fff",
          }}
        >
          {content}
        </Box>
      </Collapse>
    </div>
  );
};

export default CustomSimpleAccordion;
